<template>
  <img class="dr-biz-logo" :src="logoUrl" :style="{ height: height + 'px' }" @click="goLink" alt="logo" />
</template>

<script>
/**
 * 装修业务组件：站点 Logo
 * 优先级：customLogo (装修配置) > localStorage.shop_logo > 默认空
 */
export default {
  name: 'DrLogoBlock',
  props: {
    customLogo: { type: String, default: '' },
    height: { type: Number, default: 40 },
    link: { type: String, default: '/' }
  },
  computed: {
    logoUrl() {
      return this.customLogo || (typeof localStorage !== 'undefined' && localStorage.getItem('shop_logo')) || ''
    }
  },
  methods: {
    goLink() {
      if (this.link) this.$router.push(this.link)
    }
  }
}
</script>

<style scoped>
.dr-biz-logo { cursor: pointer; vertical-align: middle; object-fit: contain; }
</style>
